// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//= require plyr

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "bootstrap"


Rails.start()
Turbolinks.start()
ActiveStorage.start()

var jQuery = require("jquery");

// include jQuery in global and window scope (so you can access it globally)
// in your web browser, when you type $('.div'), it is actually refering to global.$('.div')
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;


// app/javascript/packs/application.js
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import Chart from 'chart.js/auto';

const application = Application.start();
const context = require.context("../controllers", true, /\.js$/);
application.load(definitionsFromContext(context));
import './confirm.js';
import './tables.js';
import './form.js';


$(document).on("turbolinks:load", function() {

  $(document).on('click', '.close-alert', function(){
    $(".close-alert").parents(".alert").remove();
  });

  $(".text-secondary[data-toggle='tooltip']").tooltip();

  var video = document.querySelector('#plyr-player');
  if (video){
    if (Hls.isSupported()) {
      var hls = new Hls();
      hls.loadSource($(video).data('src'));
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED,function() {
        video.play();
      });
    }
    // if (plyr !== undefined){
    //   plyr.setup(video);
    // }
  }

  $("#addVideoModal").on("hidden.bs.modal",function(){
    console.log("hidden.bs.modal");
    $('#plyr-player-video').attr("src", "");
  });
  
  // show published / live content
  $('.publish-tab-content').on('click', function(){
    $(".published").removeClass('active');
    $(".tabcontent.unpublished").addClass('d-none');
    $(".tabcontent.published").removeClass('d-none');
    $(this).addClass('active');
  })

  // show unpublished / recorded content
  $('.unpublish-tab-content').on('click', function(){
    $(".published").removeClass('active');
    $(".tabcontent.unpublished").removeClass('d-none');
    $(".tabcontent.published").addClass('d-none');
    $(this).addClass('active');
  });

  $('.monthsSelect').on('change', function(){
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        let result = JSON.parse(xhr.responseText);
        statsChart.data.datasets[0].data = result.video_views;
        statsChart.data.datasets[1].data = result.stream_views;
        statsChart.update();
      }
    }
    xhr.open('GET', '/admin/stats/' + $(this).val(), true);
    xhr.send(null);
  });

  $('.monthsSelect').trigger('change');

  if ($("#viewsChart").length > 0){
    var statsChart = new Chart("viewsChart", {
      type: "line",
      labels: ["2023-09-11", "2023-09-12"],
      data: {
        datasets: [{
          data: [],
          borderColor: "red",
          backgroundColor: "red",
          fill: false,
          label: "Videos"
        },{
          data: [],
          borderColor: "#3077FF",
          backgroundColor: "#3077FF",
          fill: false,
          label: "Streams"
        }]
      },
      options: {
        legend: {display: false},
      }
    });
  }
});
